import {ReactNode} from "react";
import {css, Theme} from "@emotion/react";
import {Row} from "@pg-design/grid";
import {backgroundColor, borderRadius, calculateRemSize, onDesktop, p} from "@pg-design/helpers-css";

interface ISubscriptionBoxProps {
    children: ReactNode;
}

export const SubscriptionBox = ({children}: ISubscriptionBoxProps) => {
    return <Row css={[wrapper, categoryBox]}>{children}</Row>;
};

const wrapper = css`
    row-gap: ${calculateRemSize(2)};
`;

const categoryBox = (theme: Theme) => css`
    ${backgroundColor(theme.colors.gray["200"])};
    ${p(2, 0, 2, 0)};
    ${borderRadius(2)};

    ${onDesktop(css`
        ${p(3)};
    `)};
`;
